/* this file added by Bearer Web Developer  */
import { useAppState } from '../../../../states/app-state';
import { useThemeMode } from '../../../../states/contexts/theme';
import getActiveVehicles from './getActiveVehicles';
import styles from './modeOfTransport.module.scss';
export enum vehicle_type {
    walking = "walking",
    riding = "riding",
    cycling = "cycling",
    driving = "driving", // added by Bearer Web Developer
    drone = "drone", // added by Bearer Web Developer
    rover = "rover",// added by Bearer Web Developer
}
const ModeOfTransport: React.FC = () => {
    const appState = useAppState();
    const bearer_type = appState?.ReservedOrders.activeManageOrder?.bearer_type;
    const activeVehicles = getActiveVehicles(bearer_type as vehicle_type);
    const { theme } = useThemeMode();
    return (
        <div className={styles.mode_of_transport} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <h4>Mode(s) of Transport:</h4>
            <div className={styles.modes}>
                <div className={`${styles.mode_type} ${activeVehicles.riding ? styles.active_mode_type : ''}`}>
                    {
                        theme === "dark" ? <img src="motorcycle-white.svg" alt="" />
                            : <img src="motorcycle.png" alt="" />
                    }
                </div>
                <div className={`${styles.mode_type} ${activeVehicles.cycling ? styles.active_mode_type : ''}`}>
                    {
                        theme === "dark" ? <img src="pedal-bike-white.svg" alt="" />
                            : <img src="pedal_bike_transport_info.png" alt="" />
                    }
                </div>
                <div className={`${styles.mode_type} ${activeVehicles.walking ? styles.active_mode_type : ''}`}>
                    {
                        theme === "dark" ? <img src="directions-run-white.svg" alt="" />
                            : <img src="directions_run_transport_info.png" alt="" />
                    }
                </div>
                <div className={`${styles.mode_type} ${activeVehicles.driving ? styles.active_mode_type : ''}`}>
                    {
                        theme === "dark" ? <img src="car-white.svg" alt="" />
                            : <img src="car.webp" alt="" />
                    }
                </div>
                <div className={`${styles.mode_type} ${activeVehicles.drone ? styles.active_mode_type : ''}`}>
                    {
                        theme === "dark" ? <img src="drone-white.svg" alt="" width={31} height={31} />
                            : <img src="drone.webp" alt="" />
                    }
                </div>
                <div className={`${styles.mode_type} ${activeVehicles.rover ? styles.active_mode_type : ''}`}>
                    {
                        theme === "dark" ? <img src="rover-white.svg" alt="" />
                            : <img src="rover.webp" alt="" />
                    }
                </div>
            </div>
        </div>
    )
}
export default ModeOfTransport;